import "./ProductItem.scss"
import numeral from "numeral"
import React from "react"
import { Link } from "react-router-dom"
import { observer } from "mobx-react"

const ProductItem = ({ product }) => (
  <Link className="ProductItem" to={`/products/${product.id}`}>
    <div className="ProductItem_image">
      <img src={product.images[0]} alt="" />
    </div>
    <div className="ProductItem_content">
      <h5 className="ProductItem_name">{product.name}</h5>
      <p className="ProductItem_color">{product.color}</p>
      <p className="ProductItem_price">
        {numeral(product.baseprice).format("$0.00")}
      </p>
    </div>
  </Link>
)

ProductItem.displayName = "ProductItem"

export default observer(ProductItem)



// WEBPACK FOOTER //
// ./src/products/list/ProductItem.js